import { useAdminAuthContext } from "./useAdminAuthContext";
import { Link,useNavigate } from "react-router-dom";

export const useAdminLogout = () => {

    const { dispatch } = useAdminAuthContext();
    const navigate = useNavigate();

    
    const logout = () => {
     //remove user from local storage
     localStorage.removeItem('admin');
     //dispatch logout action
     dispatch({type: 'ADMIN_LOGOUT'});
     navigate('/administrator/login');
     
    }
    return { logout };
}